


























import {Component, Prop, Vue} from 'vue-property-decorator';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import AmetrasDynamicContent from '@/views/AmetrasDynamicContent.vue';
import {ResizeSensor} from 'css-element-queries';
import {throttle} from 'lodash';
import {MovableUtils} from '@/utils/movable.utils';

/**
 * This is a component that can render dynamic contents
 */
@Component({
  name: 'ametras-dynamic-content-overlay',
  components: {
    AmetrasDynamicContent,
  }
})
export default class AmetrasDynamicContentOverlay extends Vue {

  @Prop() show!: boolean;
  @Prop() closable!: boolean;
  @Prop() position!: DisguiseDto.FlyingComponentPositionDto;
  @Prop() object!: any;
  @Prop() maxWidthInPx!: number;
  @Prop() maxHeightInPx!: number;
  @Prop() maxHeightFitContent!: boolean;
  @Prop() dynamicContent!: DisguiseDto.DynamicContentUnion;
  // optional and used in formular only
  @Prop() overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
  @Prop() contentTitle!: string;
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) editKey!: CompositeKeyType;
  showMenu: boolean = true;
  calculatedMaxWidth: number = 700;

  $refs!: {
    menu: Vue,
    content: Vue,
  };

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });
  private movable: MovableUtils | undefined;

  private throttledRepositioning = throttle(() => {
    this.calculatedMaxWidth = this.maxWidthInPx || 700;
    if (this.position && this.$refs.menu && this.$refs.content) {
      const positionableEl = this.$refs.menu.$children[0].$el;
      if (positionableEl instanceof HTMLElement) {
        const contentEl = this.$refs.content.$el;
        this.repositionPositionableEl(positionableEl, contentEl.clientWidth);
      }
    }
  }, 100);

  mounted() {
    const contentEl = this.$refs.content.$el;
    const resizeSensor = new ResizeSensor([
      document.body,
      contentEl
    ], this.throttledRepositioning);
    Vue.nextTick().then(() => {
      this.throttledRepositioning();
    });
    if (this.position && this.position.movable) {
      this.movable = new MovableUtils('.v-menu__content.menuable__content__active',
          (mouseTarget: HTMLElement) => {
            return (mouseTarget.classList.contains('v-card__title')
                || mouseTarget.classList.contains('v-toolbar__content')
                || mouseTarget.closest('.v-card__title') !== null
                || mouseTarget.closest('.v-toolbar__content') !== null)
                && mouseTarget.closest('button') === null;
          });
    }
  }

  destroyed() {
    if (this.movable) {
      this.movable.unregister();
    }
  }

  closeMenu(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    event.stopImmediatePropagation();
    if (this.closable) {
      this.$emit('close');
    }
  }

  private repositionPositionableEl(movableEl: HTMLElement, containerInnerWidth: number = 0) {
    let calculatedMaxWidth = this.maxWidthInPx || 700;

    let currentTraverseEl: Element | null = this.$el;
    let parentWidth = 0;
    while (currentTraverseEl) {
      const currentScrollbarWidth = currentTraverseEl.clientWidth;
      if (currentScrollbarWidth > 0) {
        parentWidth += currentScrollbarWidth;
        break;
      }
      currentTraverseEl = currentTraverseEl.parentElement;
    }
    const availableWidth = parentWidth;

    if (calculatedMaxWidth > availableWidth) {
      calculatedMaxWidth = availableWidth;
    }
    this.calculatedMaxWidth = calculatedMaxWidth;

    const newStyle: {
      top?: string,
      right?: string,
      bottom?: string,
      left?: string,
      marginLeft?: string,
      marginTop?: string,
      marginBottom?: string,
      marginRight?: string,
    } = {};

    if (this.position.topInPx !== undefined) {
      newStyle.top = this.position.topInPx + 'px';
    } else if (this.position.bottomInPx === undefined) {
      // absolute position disabled
      if (this.position.centerY) {
        // center y
        newStyle.top = '0';
        newStyle.bottom = '0';
        newStyle.marginTop = 'auto';
        newStyle.marginBottom = 'auto';
      } else if (this.position.belowNavigation) {
        // below navi
        newStyle.top = this.$vuetify.application.top + 'px';
      }
    }

    if (this.position.leftInPx !== undefined) {
      newStyle.left = this.position.leftInPx + 'px';
    } else if (this.position.rightInPx === undefined) {
      // absolute position disabled
      if (this.position.centerX) {
        const calculatedOffsetLeft = (window.innerWidth - containerInnerWidth) / 2;
        if (calculatedOffsetLeft < this.$vuetify.application.left) {
          newStyle.left = this.$vuetify.application.left + 'px';
          newStyle.right = 'auto';
        } else {
          // center x
          newStyle.left = '0';
          newStyle.right = '0';
          newStyle.marginLeft = 'auto';
          newStyle.marginRight = 'auto';
        }
      }
    } else {
      newStyle.left = 'auto';
    }
    if (this.position.rightInPx !== undefined && this.position.centerX === undefined) {
      newStyle.right = this.position.rightInPx + 'px';
    }
    if (this.position.bottomInPx !== undefined && this.position.centerY === undefined) {
      newStyle.bottom = this.position.bottomInPx + 'px';
    }

    Object.assign(
        movableEl.style,
        newStyle
    );

  }

}
